import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { ApprovalOperation } from '../../types';
import { UnreachableI18nCaseError } from '../../utils/i18nUtils';
import { getTranslatedApprovalType } from '../../utils/translationUtils';
import { jsx as _jsx } from "react/jsx-runtime";
export function SuccessAlertI18nTitleText(props) {
  const {
    approvalOperation
  } = props;
  switch (approvalOperation) {
    case ApprovalOperation.REQUEST:
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.updateAlertTitle.CREATE"
        });
      }
    case ApprovalOperation.APPROVE:
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.updateAlertTitle.APPROVE"
        });
      }
    case ApprovalOperation.RECALL:
    case ApprovalOperation.CANCEL:
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.updateAlertTitle.CANCEL"
        });
      }
    case ApprovalOperation.REJECT:
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.updateAlertTitle.REJECT"
        });
      }
    default:
      throw new UnreachableI18nCaseError(approvalOperation);
  }
}
export function SuccessAlertI18nMessage(props) {
  const {
    approvalOperation,
    approvalType,
    assetName
  } = props;
  const approvalTypeName = getTranslatedApprovalType(approvalType);
  const options = {
    approvalType: approvalTypeName,
    assetName
  };
  switch (approvalOperation) {
    case ApprovalOperation.REQUEST:
      {
        return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "productApprovals.updateAlertMessage.CREATE",
          options: options
        });
      }
    case ApprovalOperation.APPROVE:
      {
        return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "productApprovals.updateAlertMessage.APPROVE",
          options: options
        });
      }
    case ApprovalOperation.RECALL:
    case ApprovalOperation.CANCEL:
      {
        return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "productApprovals.updateAlertMessage.CANCEL",
          options: options
        });
      }
    case ApprovalOperation.REJECT:
      {
        return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "productApprovals.updateAlertMessage.REJECT",
          options: options
        });
      }
    default:
      throw new UnreachableI18nCaseError(approvalOperation);
  }
}